export const EARLY_ACCESS_PILOT_LABEL = 'Early Access Pilot';
export const EARLY_ACCESS_PILOT_SUMMARY =
  'Expect occasional bugs, tuning changes, and short downtime as we improve the experience.';
export const EARLY_ACCESS_PILOT_MESSAGE = `You're playing an ${EARLY_ACCESS_PILOT_LABEL}. ${EARLY_ACCESS_PILOT_SUMMARY}`;

const STAGING_ENVIRONMENT = 'staging';

export const isEarlyAccessPilotEnvironment = (environment: string) => {
  const shouldShowEarlyAccessPilot = environment === STAGING_ENVIRONMENT;
  return shouldShowEarlyAccessPilot;
};
